import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row } from 'react-bootstrap';
import { DateInput, Input } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const CloneDateForm = ({ error, handleSubmit, pristine, submitSucceeded, initialValues, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row className='invisible'>
				<Field name='weekId' component={Input} type='hidden' />
				<Field name='sourceDate' component={Input} type='hidden' />
			</Row>
			<DateInput name='date' label={t('Workshop_Clone_NewDate')} validators={validators.required} required horizontal labelCol={4} valueCol={6}/>
		</Form>
	);
};

export default reduxForm({ form: 'cloneDate' })(withTranslation()(CloneDateForm));